<template>
  <main class="main" role="main">
    <router-view v-slot="{ Component }">
      <keep-alive :include="keepAlive">
        <component :is="Component" :key="route.fullPath" />
      </keep-alive>
    </router-view>
  </main>
</template>

<script setup>
import Util from '@/common/utils/Util';
import { useRoute, useRouter } from 'vue-router';
import { computed, onBeforeMount, onUnmounted, ref, watch } from 'vue';
import { useStore } from 'vuex';

const $store = useStore();
const { path } = useRoute();
const { replace, push } = useRouter();
const { params } = useRoute();
const { nativeTel, translator } = Util;
const route = useRoute();

onBeforeMount(() => {
  $store.dispatch('store/hitStore', params.storeNo);
});

onUnmounted(() => {
  $store.commit('store/initStoreInfo');
});

const keepAlive = computed(() => $store.getters['layout/keepAliveList']);
</script>
<style scoped lang="scss"></style>
<script>
export default {
  name: 'STORE'
};
</script>
